import { ErrorBase } from '@/errors/ErrorBase';

export class UnexpectedError extends ErrorBase {
    static get defaultMessage(): string {
        return 'エラーが発生しました。もう一度ログインしてください。';
    }

    static get errorName(): string {
        return 'UnexpectedError';
    }
}
